<template>
  <section class="body-sign">
    <div class="center-sign">
      <a href="/" class="logo float-left mt-3">
        <img src="/img/logo-short-color.png" height="40" alt="Estoque Auto Logo" />
      </a>
      <div class="panel card-sign">
        <div class="card-title-sign mt-3 text-right">
          <h2 class="title text-uppercase font-weight-bold m-0"><i class="fas fa-user mr-1"></i> Cadastro grátis</h2>
        </div>
        <div class="card-body">
          <h4 class="mt-0 mb-4 font-weight-bold">
            3. Contato<br />
            <small class="text-muted">Informe os seus dados de contato e da empresa.</small>
          </h4>
          <form action="/auth/login" id="form" method="post">
            <div class="form-group mb-3">
              <label>Seu celular</label>
              <div class="input-group">
                <the-mask placeholder="(00) 00000-0000" :mask="['(##) ####-####', '(##) #####-####']" type="tel" v-model="userData.Telefone
                          " class="form-control-lg form-control" @focus.native="removeError('Celular')" />
                <span class="input-group-append">
                  <span class="input-group-text">
                    <i class="fas fa-mobile-alt"></i>
                  </span>
                </span>
              </div>
              <span class="text-danger">{{ errors['Telefone'] }}</span>

            </div>
            <div class="form-group mb-3">
              <div class="clearfix">
                <label class="float-left">Seu nome</label>
              </div>
              <div class="input-group">
                <input class="form-control form-control-lg" v-model="userData.TratarCom" type="text" />
                <span class="input-group-append">
                  <span class="input-group-text">
                    <i class="fas fa-address-book"></i>
                  </span>
                </span>
              </div>
              <span class="text-danger">{{ errors['TratarCom'] }}</span>

            </div>
            <div class="form-group mb-3">
              <label>Telefone da empresa</label>
              <div class="input-group">
                <the-mask placeholder="(00) 00000-0000" :mask="['(##) ####-####', '(##) #####-####']" type="tel" v-model="userData.TelefoneCom
                          " class="form-control-lg form-control" @focus.native="removeError('Telefone')" />
                <span class="input-group-append">
                  <span class="input-group-text">
                    <i class="fas fa-phone"></i>
                  </span>
                </span>
              </div>
              <span class="text-danger">{{ errors['TelefoneCom'] }}</span>

            </div>

            
            <div class="form-group mb-3">
              <div class="clearfix">
                <label class="float-left">Setor (opcional)</label>
              </div>
              <div class="input-group">
                <input class="form-control form-control-lg" v-model="userData.Setor" type="text" />
                <span class="input-group-append">
                  <span class="input-group-text">
                    <i class="fas fa-align-center"></i>
                  </span>
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <button type="button" @click="anterior()" class="btn btn-default mt-2 float-left" id="entrar" :disabled="loading">
                  {{loading ? 'Autenticando' : 'Voltar'}}
                </button>
                <button type="button" @click="proximo()" class="btn btn-primary mt-2 float-right" id="entrar" :disabled="loading">
                  {{loading ? 'Autenticando' : 'Próximo'}}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <p class="text-center text-muted mt-3 mb-3">&copy; Estoque Auto. Todos os direitos reservados.</p>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import {getCurrentUser,setCurrentUser,userEmpty } from '@/services/external.helpers.js';

export default {
    data() {
        return {
            userData: userEmpty(),
          errors: {},
            loading: false
        };
    },
    created() {
        this.userData = getCurrentUser();
    },
    methods: {
      proximo: function () {
        if (this.validar()) {
          setCurrentUser(this.userData);
          this.$router.push('/cadastro/regras');        
        }else {
          window.scrollTo(0,0);
        }
            
      },
      anterior: function () {
        setCurrentUser(this.userData);

          this.$router.push('/cadastro/endereco');                    
      },
      removeError(prop) {
        this.errors[prop] = '';
        delete this.errors[prop];

        this.$nextTick(() => {
          let obj = new Object();
          for (var i in this.errors) {
            obj[i] = this.errors[i];
          }
          this.errors = obj;
        });
      },
      validar() {
        this.errors = {};

        if (this.userData.Telefone.length < 9) {
          this.errors['Telefone'] = 'Número inválido.';
        }
        if (this.userData.TelefoneCom.length < 9) {
          this.errors['TelefoneCom'] = 'Número inválido.';
        }
        
        if (!this.userData.TratarCom || this.userData.TratarCom.length == 1) {
          this.errors['TratarCom'] = 'Informe o nome do responsável pela empresa.';
        }

        return Object.keys(this.errors).length === 0;
      },

    },
}

</script>
